import { TeacherActivity } from '../mockLesson';
import LessonExercisesEditor from '../component/LessonExercisesEditor';

interface LessonExercisesPageProps {
    activities: TeacherActivity[];
    selectedActivity: TeacherActivity | null;
    onSelectActivity: (activity: TeacherActivity) => void;
    onSelectLanguage: () => void;
    onBack: () => void;
    onFinish: () => void;
}

export default function LessonExercisesPage(props: LessonExercisesPageProps) {
    return (
        <LessonExercisesEditor
            activities={props.activities}
            selectedActivity={props.selectedActivity}
            onSelectActivity={props.onSelectActivity}
            onSelectLanguage={props.onSelectLanguage}
            onBack={props.onBack}
            onFinish={props.onFinish}
        />
    );
}
